import { $window } from 'util/global';

export function getOrientation($target, $existingTooltip) {
    const result = [];
    const offset = $target.offset();
    const $w = $window;
    const vmid = $w.width() / 2;
    let toptolerance = offset.top - $w.scrollTop();

    if ($existingTooltip) {
        // if we have access to the tooltip, make sure the tooltip can fit above the target
        toptolerance -= $existingTooltip.height() + 50;
    } else {
        // if we don't know the height, target must be > 300px from the top of the pane
        toptolerance -= 300;
    }

    result.push(offset.left > vmid ? 'right' : 'left');
    result.push(toptolerance > 0 ? 'top' : 'bottom');
    return result.join(' ');
}

export function repositionTooltip({
    $target, $tooltip, topOffset, leftOffset, zOffset, offsetMethod,
}) {
    const result = {};
    const offset = offsetMethod === 'position' ? $target.position() : $target.offset();
    const classes = $tooltip.attr('class').split(' ');
    const layerSubheader = 300;
    const layerModal = 700;
    let zIndex = zOffset;
    if (zIndex === undefined) {
        zIndex = $target.parents('.modal,.nf-feeditem-modal').length ? layerModal : layerSubheader;
    }

    if (classes.indexOf('top') !== -1) {
        result.top = offset.top - ($tooltip.outerHeight() + topOffset);
    } else {
        result.top = offset.top + $target.height() + topOffset;
    }
    if (classes.indexOf('left') !== -1) {
        result.left = (offset.left + ($target.width() / 2)) + leftOffset;
    } else {
        result.left = (offset.left - $tooltip.outerWidth() - leftOffset) + ($target.width() / 2);
    }

    return {
        zIndex,
        top: result.top,
        left: result.left,
    };
}
